module.exports = __webpack_public_path__ + "static/media/sun-glasses-3.dbf9ac71.jpg";